module.exports = __webpack_public_path__ + "static/assets/b4e8aa7e0aa3ca985fbda1f593d0ebd4.svg";